import { OutToTheEdgeOfCardCss } from 'components/shared/OutToTheEdgeOfCard';
import styled from 'styled-components';

export const StyledSummaryItem = styled.div`
  ${OutToTheEdgeOfCardCss};
  border-top: 1px solid ${({ theme }) => theme.colors.lightGray};
  padding: ${({ theme }) => theme.spacing.spacing5};
`;
